<div class="dialog-header">
  <h2 mat-dialog-title>Política de Privacidade</h2>
  <button matIconButton mat-dialog-close aria-label="Fechar">
    <span class="material-symbols-outlined" aria-hidden="true">close</span>
  </button>
</div>
<mat-dialog-content>
  <iframe
    src="assets/Anexo%20II_Pol%C3%ADtica_de_Privacidade_Externa_PinPag_2025.pdf"
    title="Política de Privacidade"
  ></iframe>
</mat-dialog-content>
